import header from './content/header.jsx';
import zalozky from './content/zalozky.jsx';
import footer from './content/footer.jsx';

import { initHeader } from './services/headerService.mjs';
import { initRozcestnik } from './services/rozcestnik/rozcestnikService.js';
import { initSluzby } from './services/sluzbyService.mjs';
import { initMujKatastr } from './services/mujKatastrService.mjs';
import { renderLoginComponent } from './components/Login';
import { getValidSetting, clearGovCookies } from './utils/common.mjs';
import { settings } from './config/settingsFactory.mjs';
import { initInfoBar } from './components/InfoBar/infoBarService.mjs';

const headerDiv = document.querySelector('#header');
headerDiv.appendChild(header());

const footerDiv = document.querySelector('#footer');
footerDiv.appendChild(footer(true));

initHeader(true);

const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);
const userData = urlParams.get('userData')?.toLowerCase() || '';

const zalozkyDiv = document.querySelector('#divZalozky');
const openServiceCodes = getValidSetting(settings.clientSettings.openServices, [], 'clientSettings.openServices')
.flatMap(group => group.services.filter(service => service.openUrl).map(service => service.code));
const openLinksCodes = getValidSetting(settings.clientSettings.openLinks, [], 'clientSettings.openLinks')
.map(link => link.code);

if (userData === 'mujkatastr') {
    zalozkyDiv.appendChild(zalozky('mujKatastr', true));
} else if (userData === 'sluzby') {
    zalozkyDiv.appendChild(zalozky('sluzby', true));
} else if (userData === 'oportalu') {
    zalozkyDiv.appendChild(zalozky('oPortalu', true));
} else if (userData === 'zivotnisituace' || !userData) {
    zalozkyDiv.appendChild(zalozky('zivotniSituace', true));
} else {
    zalozkyDiv.appendChild(zalozky('zivotniSituace', true));
    if (openServiceCodes.includes(userData.toUpperCase()) || openLinksCodes.includes(userData.toUpperCase())) {
        renderLoginComponent(userData.toUpperCase(), null);
    } else {
        window.location.href = '/';
    }
}

initMujKatastr(true);
initRozcestnik(true);
initSluzby(userData, true);
initInfoBar(true);

window.addEventListener('load', clearGovCookies);
